import React from "react";
import styled from "styled-components";

const SelectorContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const Button = styled.button`
  background-color: ${({ active }) => (active ? "#444" : "#222")};
  color: white;
  border: none;
  padding: 10px 20px;
  margin: 0 10px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: #555;
  }
`;

const RankingSelector = ({ selected, onChange }) => {
  return (
    <SelectorContainer>
      <Button
        active={selected === "champion"}
        onClick={() => onChange("champion")}
      >
        Champion
      </Button>
      <Button
        active={selected === "aspirant"}
        onClick={() => onChange("aspirant")}
      >
        Aspirant
      </Button>
    </SelectorContainer>
  );
};

export default RankingSelector;
